export enum MetaDataTab {
    MAIN = 'DATA_TAB_MAIN',
    ADDITIONAL = 'DATA_TAB_ADDITIONAL',
    PERMISSIONS = 'DATA_TAB_PERMISSIONS',
    LOCALES = 'DATA_TAB_LOCALES',
    LABELS = 'DATA_TAB_LABELS',
    DISCLAIMER = 'DATA_TAB_DISCLAIMER',
    IMAGE = 'DATA_TAB_IMAGE'
}